<template lang="pug">

div

    //- Navigation
    navigation

    //- Content
    router-view

</template>

<script>
    import Navigation from '@/components/companies/Navigation.vue'

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {
        name: 'companies-create-view',
        components: { Navigation }
    }

</script>
